import { useStaticQuery, graphql } from 'gatsby'

export function useDataAwards() {
    const data = useStaticQuery(graphql`
        {
            title: datoCmsRenshinPageAbout(title: { eq: "Title awards" }, locale: { eq: "hy" }) {
                value
            }

            items: allDatoCmsRenshinAward(sort: { fields: [sorting], order: ASC }, filter: { locale: { eq: "hy" } }) {
                nodes {
                    year
                    title
                    text
                    certificateImage {
                        url
                        width
                        height
                    }
                }
            }
        }
    `)

    return data
}
